/* eslint semi: ["error", "never"]*/
import { DECRYPT } from '@engine/actions/action-types';
/**
 * Initial state
 */

var INITIAL_STATE = {
  decryptedText: '************',
  isDecrypted: false
};
/**
 * Reducer Factory
 */

function decryptFor(field) {
  return function baseDecrypt() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case DECRYPT(field).fieldDecrypted:
        return {
          decryptedText: action.data.decrypted_attribute,
          isDecrypted: true
        };

      case DECRYPT(field).decryptFail:
        return {
          decryptedText: "".concat(I18n.t('javascript.errors.unable_to_process_request')) + " ".concat(I18n.t('javascript.errors.try_again_later')),
          isDecrypted: false
        };

      default:
        return state;
    }
  };
}

var decryptField = function decryptField(field) {
  return decryptFor(field);
};

export default decryptField;